<template>
  <InputRow v-slot="{ field: inputRowField }" v-model="selectedIds" name="eventActionRelation">
    <LISASelect
      v-model="selectedIds"
      :class="inputRowField.class"
      class="w-100"
      multiple
      selection-display="chips"
      :options="selectOptions"
    />
  </InputRow>
</template>

<script setup lang="ts">
import InputRow from "@/components/shared/form/InputRow.vue";
import { computed, ref } from "vue";
import { LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import { useTranslation } from "@/language/translation";
import EventActionRelationFilter, {
  EventActionRelationFilterOptions,
} from "../filterImplementations/EventActionRelationFilter";

const { t } = useTranslation();
const options = computed(() =>
  Object.values(EventActionRelationFilterOptions).map((filterOptionKey) => ({
    label: t(
      `components.event-action.filter.ui.badges.EventActionRelationFilterBadge.${filterOptionKey}`,
    ).toString(),
    value: filterOptionKey,
  })),
);
const selectOptions = computed<LISASelectOption[]>(() =>
  options.value.map((option, id) => ({ id, label: option.label })),
);

const selectedIds = ref<number[]>([]);

function getFilter() {
  return selectedIds.value.length === 0
    ? null
    : new EventActionRelationFilter(
        selectedIds.value.flatMap((id) => {
          const value = options.value[id]?.value;
          return value == null ? [] : [value];
        }),
      );
}

function applyFilter(filter: EventActionRelationFilter) {
  selectedIds.value = filter.filters
    .map((filterElement) => options.value.findIndex((option) => option.value === filterElement))
    .filter((id) => id >= 0);
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped></style>
